/** Main topic keys aligned with filenote.py schema_topics */
export interface TemplateTopicOption {
  key: string;
  label: string;
  description: string;
}

export const TEMPLATE_MAIN_TOPICS: TemplateTopicOption[] = [
  { key: "person", label: "Person", description: "Core information about a person, including biographical, demographic, and role-based details." },
  { key: "individual", label: "Individual", description: "Meeting participants and individual-level context (legacy templates)." },
  { key: "dependents", label: "Dependents", description: "People who rely financially or socially on the primary individual." },
  { key: "riskProfile", label: "Risk profile", description: "Client risk tolerance, investment horizon, and risk-related discussion." },
  { key: "goals", label: "Goals", description: "Financial milestones or outcomes the client aims to achieve." },
  { key: "income", label: "Income", description: "Regular and irregular inflows of money." },
  { key: "assets", label: "Assets", description: "Resources and possessions of monetary value." },
  { key: "liabilities", label: "Liabilities", description: "Financial debts and obligations." },
  { key: "expenses", label: "Expenses", description: "Outflows for living, obligations, and discretionary spending." },
  { key: "insurance", label: "Insurance", description: "Protective policies held to mitigate financial loss." },
  { key: "cashflow", label: "Cashflow", description: "Money coming in versus going out over a period." },
  { key: "scopeOfAdvice", label: "Scope of advice", description: "Range of topics the financial advice will cover." },
  { key: "clientSentiment", label: "Client sentiment", description: "Emotional tone, concerns, or attitudes expressed by the client." },
  { key: "professionalNetwork", label: "Professional network", description: "Professionals the client consults for financial or life decisions." },
  { key: "actions", label: "Actions", description: "Steps the client or advisor agree to take after the meeting." },
];

export const TEMPLATE_TOPIC_BY_KEY = Object.fromEntries(
  TEMPLATE_MAIN_TOPICS.map((t) => [t.key, t]),
) as Record<string, TemplateTopicOption>;
